import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../_models/field.interface";
@Component({
  selector: "app-buttonImage",
  template: `
<div [formGroup]="group" [hidden]="!field.visible" [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null">
    <div [ngStyle]="field.style()">
        <button class="cs_botao-imagem {{ field.class }}" (click)="field.onClick()"><label class="cs_label"><img [src]="field.icon" />{{field.label}}</label>
        </button>
    </div>
</div>
`,
  styles: []
})
export class ButtonImageComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;

  constructor() {}
  ngOnInit() {}
}
